export const FETCH_PIG_BODIES_REQUEST = "FETCH_PIG_BODIES_REQUEST";
export const FETCH_PIG_BODIES_SUCCESS = "FETCH_PIG_BODIES_SUCCESS";
export const FETCH_PIG_BODIES_FAILURE = "FETCH_PIG_BODIES_FAILURE";
export const CREATE_PIG_BODY_REQUEST = "CREATE_PIG_BODY_REQUEST";
export const CREATE_PIG_BODY_SUCCESS = "CREATE_PIG_BODY_SUCCESS";
export const CREATE_PIG_BODY_FAILURE = "CREATE_PIG_BODY_FAILURE";

export const fetchPigBodiesRequest = () => ({
  type: FETCH_PIG_BODIES_REQUEST,
});

export const fetchPigBodiesSuccess = (pigBody) => ({
  type: FETCH_PIG_BODIES_SUCCESS,
  payload: pigBody,
});
export const fetchPigBodiesFailure = (error) => ({
  type: FETCH_PIG_BODIES_FAILURE,
  payload: error,
});

export const createPigBodyRequest = () => ({
  type: CREATE_PIG_BODY_REQUEST,
});

export const createPigBodySuccess = (createdPigBodies) => ({
  type: CREATE_PIG_BODY_SUCCESS,
  payload: createdPigBodies,
});

export const createPigBodyFailure = (error) => ({
  type: CREATE_PIG_BODY_FAILURE,
  payload: error,
});
